var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('slide-navbar-component'),_c('navbar-component'),_c('banner-component',{attrs:{"bannerTitle":"CONTACT US","bannerImage":_vm.bannerImage}}),_c('form-layout'),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }